import React, { useEffect, useState } from "react";
import { useAppContext } from "../../contexts/AppContext";
import axios from "axios";
import parse from "html-react-parser";

function Statics() {
  const [staticsData, setStaticsData] = useState([]);
  const { backendUrl, translate } = useAppContext();
  const staticsRoute = "/statics";

  const healthIcons = [
    { icon: "bi-heart-pulse-fill" },
    { icon: "bi-shield-plus" },
    { icon: "bi-person-hearts" },
    { icon: "bi-activity" },
    { icon: "bi-hospital" },
    { icon: "bi-capsule-pill" },
    { icon: "bi-bandaid" },
    { icon: "bi-clipboard2-pulse-fill" },
  ];

  useEffect(() => {
    const fetchStaticsData = async () => {
      try {
        const response = await axios.get(`${backendUrl}${staticsRoute}`);
        if (Array.isArray(response.data)) {
          setStaticsData(response.data);
        }
      } catch (error) {
        console.error("Error fetching statics data:", error);
      }
    };
    fetchStaticsData();
  }, [backendUrl]);

  return (
    <div>
      {Array.isArray(staticsData) && staticsData.length > 0 && (
        <div className="statics-container animated">
          <div className="p-1 d-flex w-100 justify-content-around flex-wrap">
            {staticsData.map((stat, index) => {
              const iconConfig = healthIcons[index % healthIcons.length];
              return (
                <div key={index} className="m-3">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <div
                      style={{
                        width: "72px",
                        height: "72px",
                        borderRadius: "50%",
                        background: "var(--primary-color)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "0.75rem",
                        transition: "transform 0.3s ease",
                      }}
                      onMouseEnter={e => {
                        e.currentTarget.style.transform = "scale(1.12) translateY(-5px)";
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.transform = "scale(1) translateY(0)";

                      }}
                    >
                      <i
                        className={`bi ${iconConfig.icon}`}
                        style={{ fontSize: "2rem", color: "white", filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))" }}
                      />
                    </div>
                    <h2 className="fw-bold mb-0" style={{ color: "#1e293b" }}>
                      {stat.title ? parse(translate(stat.title)) : ""}
                    </h2>
                    <p className="text-muted text-center" style={{ fontWeight: 400, fontSize: "0.95rem", maxWidth: "200px" }}>
                      {stat.content ? parse(translate(stat.content)) : ""}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default Statics;
